export default __webpack_public_path__ + "static/media/eu.bd299e10.mp4";